import { gql } from '@apollo/client';

export const FETCH_MITIGATION_DASHBOARD = gql`
  query ProcessAreaAndProcessMitigationDashboard($uuid: ID!) {
    processAreaAndProcessMitigationDashboard(uuid: $uuid) {
      externalMitigation
      finishedGoods
      internalMitigation
      onsiteMitigation
      procesess {
        externalMitigation
        finishedGoods
        internalMitigation
        onsiteMitigation
        process
        processUUID
        replacementTime
        residualRevenueExposure
        totalMitigation
        totalRevenueExposure
      }
      processArea
      processAreaUUID
      replacementTime
      residualRevenueExposure
      totalMitigation
      totalRevenueExposure
    }
  }
`;

export const GET_MITIGATION_PROCESS_AREA = gql`
  query GetMitigationQuantificationPerProcessArea(
    $data: MitigationQuantificationPerProcessAreaInput!
  ) {
    getMitigationQuantificationPerProcessArea(data: $data) {
      uuid
      name
      dependencySupportRevenue
      __typename
      mitigation {
        externalDelay
        externalPercentage
        internalDelay
        internalPercentage
        onsiteDelay
        onsitePercentage
        strategyComment
        uuid
      }
      productGroups {
        uuid
        name
        dependencySupportRevenue
        products {
          uuid
          name
          dependencySupportRevenue
          mitigation {
            uuid
            externalDelay
            externalPercentage
            internalDelay
            internalPercentage
            onsiteDelay
            onsitePercentage
            strategyComment
          }
        }
        mitigation {
          uuid
          externalDelay
          externalPercentage
          internalDelay
          internalPercentage
          onsiteDelay
          onsitePercentage
          strategyComment
        }
      }
    }
  }
`;

export const GET_MITIGATION_PROCESS = gql`
  query GetMitigationQuantificationPerProcess(
    $data: MitigationQuantificationPerProcess!
  ) {
    getMitigationQuantificationPerProcess(data: $data) {
      uuid
      name
      dependencySupportRevenue
      mitigation {
        uuid
        externalDelay
        externalPercentage
        internalDelay
        internalPercentage
        onsiteDelay
        onsitePercentage
        strategyComment
      }
      productGroups {
        uuid
        name
        dependencySupportRevenue
        products {
          uuid
          name
          dependencySupportRevenue
          mitigation {
            uuid
            externalDelay
            externalPercentage
            internalDelay
            internalPercentage
            onsiteDelay
            onsitePercentage
            strategyComment
          }
        }
        mitigation {
          uuid
          externalDelay
          externalPercentage
          internalDelay
          internalPercentage
          onsiteDelay
          onsitePercentage
          strategyComment
        }
      }
      intermediates {
        uuid
        name
        dependencySupportRevenue
        mitigation {
          externalDelay
          externalPercentage
          internalDelay
          internalPercentage
          onsiteDelay
          onsitePercentage
          strategyComment
          uuid
        }
      }
    }
  }
`;

export const UPDATE_MITIGATION_PROCESS_AREA = gql`
  mutation UpdateProcessAreaMitigation(
    $data: UpsertProcessAreaMitigationInput!
  ) {
    upsertProcessAreaMitigation(data: $data) {
      externalDelay
      externalPercentage
      internalDelay
      internalPercentage
      onsiteDelay
      onsitePercentage
      strategyComment
    }
  }
`;

export const UPDATE_MITIGATION_PROCESS = gql`
  mutation UpdateProcessMitigation($data: UpsertProcessMitigationInput!) {
    upsertProcessMitigation(data: $data) {
      externalDelay
      externalPercentage
      internalDelay
      internalPercentage
      onsiteDelay
      onsitePercentage
      strategyComment
    }
  }
`;

export const UPDATE_PROCESS_AREA_COMMENTARY = gql`
  mutation UpdateCommentary($data: UpdateProcessAreaInput!) {
    updateProcessArea(data: $data) {
      comment
      processArea
      replacementCost
      replacementTime
      strategyComment
      underlyingProcesses
      uuid
    }
  }
`;

export const GET_PROCESS_AREA_COMMENTARY = gql`
  query GetCommentary($uuid: ID!) {
    findProcessAreaByUuid(uuid: $uuid) {
      comment
      processArea
      replacementCost
      replacementTime
      strategyComment
      underlyingProcesses
      uuid
    }
  }
`;

export const UPDATE_PROCESS_COMMENTARY = gql`
  mutation UpdateProcessCommentary($data: UpdateProcessesInput!) {
    updateProcesses(data: $data) {
      process
      replacementCost
      replacementTime
      strategyComment
      uuid
    }
  }
`;

export const GET_PROCESS_COMMENTARY = gql`
  query GetProcessCommentary($uuid: ID!) {
    findProcessesByUuid(uuid: $uuid) {
      comment
      process
      replacementCost
      replacementTime
      strategyComment
      uuid
    }
  }
`;
